import React, { useState, useEffect } from 'react';
import { pumps as initialPumps } from '../../data/appData';
import { BASE_URL } from '../../services/api';
import './Pump.css';

const emptyForm = {
  pumpNo: '',
  name: '',
  tankId: '',
  product: '',
  nozzles: '',
  status: ''
};

export default function Pump({ user }) {
  const companyId = user?.Companyid || user?.company_id || "1";

  const [pumpList, setPumpList] = useState(initialPumps);
  const [products, setProducts] = useState([]);
  const [tanks, setTanks] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);
  const [form, setForm] = useState(emptyForm);

  /* ================= VALIDATION ================= */

  const validateForm = () => {

    if (!String(form.pumpNo || '').trim()) {
      alert("Pump No is required");
      return false;
    }

    if (!/^\d+$/.test(form.pumpNo)) {
      alert("Pump No must contain only numbers");
      return false;
    }

    if (!String(form.name || '').trim()) {
      alert("Pump Name is required");
      return false;
    }

    if (!String(form.tankId || '').trim()) {
      alert("Tank Name is required");
      return false;
    }

    if (!String(form.product || '').trim()) {
      alert("Product is required");
      return false;
    }

    if (!form.nozzles || Number(form.nozzles) <= 0) {
      alert("Nozzles must be greater than 0");
      return false;
    }

    if (!form.status) {
      alert("Status is required");
      return false;
    }

    return true;
  };

  /* ================= LOAD PRODUCTS ================= */

  const loadProducts = async () => {

    try {
      const res = await fetch(`${BASE_URL}Pages/ProductView.php`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ Companyid: companyId })
        }
      );

      const data = await res.json();

      if (data.success) {

        const list = Array.isArray(data.Response)
          ? data.Response
          : [data.Response];

        setProducts(list);

      }

    } catch (err) {
      console.error("ProductView API error:", err);
    }

  };

  /* ================= LOAD TANKS ================= */

  const loadTanks = async () => {

    try {
      const res = await fetch(`${BASE_URL}Pages/TankView.php`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ Companyid: companyId })
        }
      );

      const data = await res.json();

      if (data.success) {

        const tankList = Array.isArray(data.Response)
          ? data.Response
          : [data.Response];

        setTanks(tankList);

      }

    } catch (err) {
      console.error("TankView API error:", err);
    }

  };

  /* ================= LOAD PUMPS ================= */

  const loadPumps = async () => {

    try {
      const res = await fetch(`${BASE_URL}Pages/PumpView.php`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ Companyid: companyId })
        }
      );

      const data = await res.json();

      if (data.success) {

        const pumpArray = Array.isArray(data.Response)
          ? data.Response
          : [data.Response];

        const formatted = pumpArray.map(pump => {
          // Robustly find the tank name in various possible API fields
          const tName = pump.TankName || pump.Tank || pump.Tank_Name || pump.Tankid || "";
          
          return {
            id: pump.Pumpid,
            // Use PumpNo if it exists, otherwise fall back to Pumpid
            pumpNo: String(pump.PumpNo || pump.Pump_no || pump.Pumpid || ""),
            name: pump.PumpName,
            tankId: tName,
            tankName: tName,
            product: pump.ProductName,
            nozzles: Number(pump.Nozzles || 0),
            status: pump.Status
          };
        });

        setPumpList(formatted);

      }

    } catch (err) {
      console.error("PumpView API error:", err);
    }

  };

  useEffect(() => {

    loadPumps();
    loadProducts();
    loadTanks();

  }, []);

  /* ================= ADD ================= */

  const openAdd = () => {
    setEditId(null);
    setForm(emptyForm);
    setShowForm(true);
  };

  /* ================= EDIT ================= */

  const openEdit = (p) => {

    setEditId(p.id);

    setForm({
      pumpNo: String(p.pumpNo || ''),
      name: p.name,
      tankId: p.tankName,
      product: p.product,
      nozzles: p.nozzles,
      status: p.status
    });

    setShowForm(true);
  };

  /* ================= SAVE ================= */

  const handleSave = async () => {

    if (!validateForm()) return;

    try {
      await fetch(`${BASE_URL}Pages/PumpReg.php`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            Companyid: companyId,
            Pump_no: form.pumpNo,
            PumpName: form.name,
            TankName: form.tankId,
            Product: form.product,
            Nozzles: String(form.nozzles),
            Status: form.status,
            IDS: editId ? String(editId) : "0"
          })
        }
      );

      loadPumps();
      setShowForm(false);

    } catch (err) {

      console.error("Pump API error:", err);
      alert("Failed to save pump.");

    }

  };

  const toggleStatus = (p) => {

    // setPumpList(prev =>
    //   prev.map(item =>
    //     item.id === p.id
    //       ? { ...item, status: item.status === 'Active' ? 'Inactive' : 'Active' }
    //       : item
    //   )
    // );

  };

  return (
    <div className="pump-page">

      <div className="page-header">
        <h2 className="page-title">Pump/Pump List</h2>
        <button className="btn btn-primary btn-sm" onClick={openAdd}>
          ＋ Add Pump
        </button>
      </div>

      {showForm && (

        <div className="section-card">

          <div className="section-header">
            {editId ? 'Edit Pump' : 'Add Pump'}
          </div>

          <div className="form-row">

            <div className="form-group">
              <label>Pump No *</label>
              <input
                className="form-control"
                value={form.pumpNo}
                placeholder=" Pump No"
                inputMode="numeric"
                onChange={e => {
                  const value = e.target.value.replace(/\D/g, "");
                  setForm({ ...form, pumpNo: value });
                }}
              />
            </div>

            <div className="form-group">
              <label>Name *</label>
              <input
                className="form-control"
                value={form.name}
                onChange={e => setForm({ ...form, name: e.target.value })}
              />
            </div>

            {/* Tank Dropdown */}

            <div className="form-group">
              <label>Tank Name *</label>

              <select
                className="form-control"
                value={form.tankId}
                onChange={e => setForm({ ...form, tankId: e.target.value })}
              >

                <option value="">Select Tank</option>

                {tanks.map(t => (
                  <option key={t.Tankid} value={t.TankName}>
                    {t.TankName}
                  </option>
                ))}

              </select>
            </div>

            <div className="form-group">
              <label>Product *</label>

              <select
                className="form-control"
                value={form.product}
                onChange={e => setForm({ ...form, product: e.target.value })}
              >

                <option value="">Select Product</option>

                {products.map(p => (
                  <option key={p.Productid} value={p.Name}>
                    {p.Name}
                  </option>
                ))}

              </select>
            </div>

            <div className="form-group">
              <label>Nozzles *</label>
              <input
                type="number"
                className="form-control"
                value={form.nozzles}
                min="1"
                max="8"
                onChange={e => setForm({ ...form, nozzles: e.target.value })}
              />
            </div>

            <div className="form-group">
              <label>Status *</label>

              <select
                className="form-control"
                value={form.status}
                onChange={e => setForm({ ...form, status: e.target.value })}
              >
                <option value="">Select Status</option>
                <option>Active</option>
                <option>Inactive</option>
              </select>

            </div>

          </div>

          <div className="action-bar" style={{ padding: '0 16px 14px' }}>

            <button className="btn btn-primary" onClick={handleSave}>
            {editId ? "Update Pump Details" : "Save Pump"}
          </button>

            <button
              className="btn btn-secondary"
              onClick={() => setShowForm(false)}
            >
              Cancel
            </button>

          </div>

        </div>

      )}

      {/* TABLE */}

      <div className="section-card">

        <div className="section-header">
          Pump List — {pumpList.length} pumps
        </div>

        <div className="table-wrapper">

          <table className="data-table">

            <thead>
              <tr>
                <th className="text-left">Name</th>
                <th className="text-left">Product</th>
                <th className="text-center">Nozzles</th>
                <th className="text-center">Status</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>

            <tbody>

              {pumpList.map((p) => (

                <tr key={p.id}>

                  <td className="text-left" style={{ fontWeight: 600 }}>{p.name}</td>
                  <td className="text-left">{p.product}</td>
                  <td className="text-center">{p.nozzles}</td>
                  <td className="text-center">
                    <span className={`badge ${p.status === 'Active' ? 'badge-success' : 'badge-warning'}`} onClick={() => toggleStatus(p)}>
                      {p.status}
                    </span>
                  </td>
                  <td className="text-center">
                    <button className="icon-btn" onClick={() => openEdit(p)}>
                      <i className="bi bi-pencil-square"></i>
                    </button>
                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>

      </div>

    </div>
  );
}